import styled from 'styled-components';

export const AccordianContainer = styled.div``;

export const AccordianItemContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AccordinHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 8px 8px 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  cursor: pointer;
`;

export const Title = styled.div`
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.63);
  font-weight: 400;
  line-height: 20px;
  font-weight: 500;
`;

export const AccordianBody = styled.div`
  padding: 5px 10px;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.93);
`;
